import React, { useState } from "react";

import * as Yup from "yup";
import { Link as RouterLink } from "react-router-dom";
import { Formik, Form, Field } from "formik";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import InputAdornment from "@mui/material/InputAdornment";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { i18n } from "../../translate/i18n";
import AuthPageLayout, {
	LS,
	useAuthPageStyles,
	NewClientContactCard,
} from "../../components/AuthPageLayout";

const UserSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, "Too Short!")
		.max(50, "Too Long!")
		.required("Required"),
	password: Yup.string().min(5, "Too Short!").max(50, "Too Long!"),
	email: Yup.string().email("Invalid email").required("Required"),
});

const SignUp = () => {
	const classes = useAuthPageStyles();
	const initialState = { name: "", email: "", password: "" };
	const [user] = useState(initialState);

	return (
		<AuthPageLayout
			heroTitle="Contrate o Multi"
			heroSubtitle="O cadastro online está indisponível. Entre em contato com a equipe Life Sip Telecom e faça uma cotação personalizada para sua necessidade agora mesmo!"
			formTitle={i18n.t("signup.title")}
			formSubtitle="Cadastro indisponível — fale com o comercial"
		>
			<Typography className={classes.disabledNotice}>
				O cadastro pelo sistema está desativado. Para novos clientes, utilize os canais
				comerciais abaixo.
			</Typography>

			<NewClientContactCard />

			<Formik
				initialValues={user}
				enableReinitialize={true}
				validationSchema={UserSchema}
				onSubmit={() => {}}
			>
				{({ touched, errors }) => (
					<Form noValidate>
						<Field
							as={TextField}
							className={classes.textField}
							autoComplete="name"
							name="name"
							error={touched.name && Boolean(errors.name)}
							helperText={touched.name && errors.name}
							variant="outlined"
							fullWidth
							id="name"
							label={i18n.t("signup.form.name")}
							disabled
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<PersonOutlineOutlinedIcon />
									</InputAdornment>
								),
							}}
						/>
						<Field
							as={TextField}
							className={classes.textField}
							variant="outlined"
							fullWidth
							id="email"
							label={i18n.t("signup.form.email")}
							name="email"
							error={touched.email && Boolean(errors.email)}
							helperText={touched.email && errors.email}
							autoComplete="email"
							disabled
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<EmailOutlinedIcon />
									</InputAdornment>
								),
							}}
						/>
						<Field
							as={TextField}
							className={classes.textField}
							variant="outlined"
							fullWidth
							name="password"
							error={touched.password && Boolean(errors.password)}
							helperText={touched.password && errors.password}
							label={i18n.t("signup.form.password")}
							type="password"
							id="password"
							autoComplete="new-password"
							disabled
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<LockOutlinedIcon />
									</InputAdornment>
								),
							}}
						/>
						<Button type="submit" fullWidth className={classes.submit} disabled>
							{i18n.t("signup.buttons.submit")}
						</Button>
						<Typography align="center" variant="body2" style={{ color: LS.textMuted }}>
							<Link component={RouterLink} to="/login" className={classes.authLink}>
								{i18n.t("signup.buttons.login")}
							</Link>
						</Typography>
					</Form>
				)}
			</Formik>
		</AuthPageLayout>
	);
};

export default SignUp;
